<template>
    <v-tab-item :value="$route.fullPath" class="pa-3">
        <v-toolbar flat height="90">
            <v-btn
                color="secondary"
                class="text-capitalize px-5"
                depressed
                v-text="translations.addExternalLink[lang]"
                @click="dialog = true"
                v-if="
                    superUser ||
                    (permissions.products.external_links.create &&
                        storePermissions.products.external_links.create)
                "
            ></v-btn>
        </v-toolbar>

        <v-data-table
            :loading="loading"
            :headers="headers"
            :items="externalLinks"
            :footer-props="{
                itemsPerPageOptions: [12],
                showCurrentPage: true,
                pageText: `${page * 12 - 11}-${
                    page * 12 <= serverItemsLength
                        ? page * 12
                        : serverItemsLength
                } ${translations.paginationText[lang]} ${serverItemsLength}`,
            }"
            :page.sync="page"
            :server-items-length="serverItemsLength"
            class="b-outlined"
        >
            <template v-slot:item.image="{ item }">
                <v-img :src="item.image" width="70" v-if="item.image"></v-img>
                <div v-else>-</div>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-tooltip color="secondary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                        :disabled="!(superUser ||
                    (permissions.products.external_links.delete &&
                        storePermissions.products.external_links.delete))"
                            color="red"
                            icon
                            v-on="on"
                            @click="
                                () => {
                                    deletingLinkId =
                                        item.store_external_link_id;
                                    deleteDialog = true;
                                }
                            "
                        >
                            <v-icon v-text="icons.mdiClose"></v-icon>
                        </v-btn>
                    </template>

                    <span
                        class="font-weight-bold"
                        v-text="translations.delete[lang]"
                    ></span>
                </v-tooltip>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="500">
            <ExternalLinkForm @cancel="dialog = false" />
        </v-dialog>

        <v-dialog v-model="deleteDialog" max-width="500">
            <b-card
                type="delete"
                title="Delete External Link"
                :submit-text="{ el: '', en: 'delete', it: '' }"
                :loading="loading"
                :error-message="errorMessage"
                @cancel="deleteDialog = false"
                @submit="remove(deletingLinkId)"
            >
                <div class="subtitle-1 font-weight-medium py-3 px-2">
                    Are you sure you want to delete External Link?
                </div>
            </b-card>
        </v-dialog>
    </v-tab-item>
</template>

<script>
import { mdiClose } from "@mdi/js";
import translations from "@/utils/translations/storePanel/products/externalLinks";
import ExternalLinkForm from "@/components/storePanel/products/ExternalLinkForm.vue";
import { mapActions, mapMutations, mapState } from "vuex";
export default {
    name: "ExternalLinks",

    components: {
        ExternalLinkForm,
    },

    mixins: [translations],

    data() {
        return {
            icons: { mdiClose },
            page: +this.$route.query.page,
            deletingLinkId: null,
        };
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "serverItemsLength",
            "permissions",
            "storePermissions",
            "superUser",
        ]),
        ...mapState("storePanel/externalLinks", ["externalLinks"]),

        lang() {
            return this.$route.params.lang;
        },

        dialog: {
            get() {
                return this.$store.state.dialog;
            },

            set(val) {
                this.setDialog(val);
            },
        },

        deleteDialog: {
            get() {
                return this.$store.state.deleteDialog;
            },

            set(val) {
                this.setDeleteDialog(val);
            },
        },

        headers() {
            return [
                {
                    text: this.translations.image[this.lang],
                    value: "image",
                },
                {
                    text: this.translations.link[this.lang],
                    value: "url",
                },
                {
                    text: this.translations.actions[this.lang],
                    value: "actions",
                },
            ];
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },
    },

    mounted() {
        this.getExternalLinks(this.query);
    },

    watch: {
        $route(val) {
            if (!val.query.page) {
                this.$router.replace({
                    query: {
                        page: 1,
                        ...this.$route.query,
                    },
                });
            }

            this.getExternalLinks(this.query);
        },

        page(page) {
            this.$router.replace({ query: { ...this.$route.query, page } });
        },
    },

    methods: {
        ...mapMutations(["setDialog", "setDeleteDialog"]),
        ...mapActions("storePanel/externalLinks", [
            "getExternalLinks",
            "remove",
        ]),
    },
};
</script>
